// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7e6c392c","856":"9d35bfb8"}[chunkId] + ".chunk.js";
};